module.exports = {"131172101":"魏家屯镇","131172203":"彭杜村乡","131172401":"滨湖新区教育园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131172.json
// module id = 254
// module chunks = 0